"use strict";
import { useCallContext } from "lib/hooks/useCallContext";
import multicall from "lib/state/multicall";
export { NEVER_RELOAD } from "@uniswap/redux-multicall";
export function useMultipleContractSingleData(...args) {
  const { chainId, latestBlock } = useCallContext();
  return multicall.hooks.useMultipleContractSingleData(chainId, latestBlock, ...args);
}
